$(document).ready(function () {
	var isMouseMove = false;
	var currentId = 0 ;
	var dial = $('.dialer-quality');
	var autoInterval;
	var isMouseDown = false;
	var radius;
	var center_x;
	var center_y;
	var mobileDegreePlus = 0;
	var currentDegree = 0;
	var degreeArray = [0, 309, 255, 158, 58];
	//	
	dial.find("*").bind('selectstart dragstart', function (evt) {
		evt.preventDefault(); return false;
	});
	function onResize() {
		if ($(window).outerWidth() < 1024) {
			mobileDegreePlus = 90;
		} else {
			mobileDegreePlus = 0;
		}
		radius = dial.outerWidth() / 2;
		center_x = dial.offset().left + radius;
		center_y = dial.offset().top + radius;
		TweenMax.set(dial, { rotation: currentDegree + mobileDegreePlus });
	}
	$(window).bind("resize", onResize)
	onResize();
	function clearAutoInterval(){		
		clearTimeout(autoInterval);
	}
	function startAutoInterval() {
		clearAutoInterval();
		if(isMouseDown){
			return;
		}
		autoInterval = setTimeout(function () {
			var length = colorOption.length;
			var nextId = (((currentId-1)%length)+length)%length;
			$(colorOption[nextId]).trigger("click");
			$(colorOption[nextId]).trigger("touchend");
		}, 7000)
	}
	function getCloseDegree(prop) {
		var currentDegree = prop.currentDegree;
		var targetDegree = prop.targetDegree;
		var tempDegree = ((currentDegree % 360) + 360) % 360
		var degDif = ((targetDegree - tempDegree) + 360) % 360;
		if (degDif > 180) {
			return -((360 - degDif) % 360);
		} else {
			return ((degDif) % 360);
		}
	}
	colorOption = dial.find("ul li a");
	colorOption.each(function (index, rel) {
		var targetDegree = degreeArray[index];
		var ele = $(this);
		var herf = ele.attr("href");
		ele.bind("click touchend", function (e) {
			if (e && e.preventDefault) {
				e.preventDefault();
			}
			if (isMouseMove) {
				return;
			}
			startAutoInterval();
			currentId = index;
			currentDegree += getCloseDegree({
				currentDegree: currentDegree,
				targetDegree: targetDegree
			})
			TweenMax.to(dial, { rotation: currentDegree + mobileDegreePlus, ease: Cubic.easeInOut, duration: 0.9 });
			//--------------------------------------------
			$(".quality-content").stop().fadeOut(600, function () {
				$(".quality-content").addClass("hide");
				$(herf).removeClass("hide");
				$(herf).stop().fadeIn(600);
			});
			//--------------------------------------------
		})
	})

	$(colorOption[0]).trigger("click")
	$(colorOption[0]).trigger("touchend")
	//-------------------------------------------------------
	function get_degrees(mouse_x, mouse_y) {
		var radians = Math.atan2(mouse_x - center_x, mouse_y - center_y);
		var degrees = Math.round((radians * (180 / Math.PI) * -1) + 100);
		return degrees;
	}
	function triggerCloseDegreeBtn() {
		var tempLongDegree = 360;
		var eleToTrigger;
		colorOption.each(function (index, rel) {
			var targetDegree = degreeArray[index];
			var ele = $(this);
			var closeDegree = Math.abs(getCloseDegree({
				currentDegree: currentDegree,
				targetDegree: targetDegree
			}))
			if (closeDegree <= tempLongDegree) {
				tempLongDegree = closeDegree;
				eleToTrigger = ele;
			}
		})
		eleToTrigger.trigger("click")
		eleToTrigger.trigger("touchend")
	}
	dial.on('mousedown touchstart', function (event) {
		var downDialDegree = currentDegree;
		isMouseDown = true;
		clearAutoInterval();
		var pageX = event.pageX;
		var pageY = event.pageY;
		if (pageX == undefined) {
			pageX = event.touches[0].pageX;
			pageY = event.touches[0].pageY;
		}
		var downMouseDegree = get_degrees(pageX, pageY);
		var moveCount = 0;
		event.preventDefault();
		function onMouseMove(event) {
			moveCount++;
			if (moveCount > 2) {
				isMouseMove = true;
			}
			var pageX = event.pageX;
			var pageY = event.pageY;
			if (pageX == undefined) {
				pageX = event.touches[0].pageX;
				pageY = event.touches[0].pageY;
			}
			var degrees = (get_degrees(pageX, pageY) - downMouseDegree);
			currentDegree = downDialDegree + degrees;
			TweenMax.set(dial, { rotation: currentDegree + mobileDegreePlus });
		}
		function onMouseUp() {
			$(document).unbind('mousemove touchmove', onMouseMove);
			$(document).unbind('mouseup touchend', onMouseUp);
			if (isMouseMove) {
				setTimeout(function () {
					isMouseMove = false;
					triggerCloseDegreeBtn();
				}, 100)
			}
			//isMouseDown = false;
		}
		$(document).bind('mousemove touchmove', onMouseMove);
		$(document).bind('mouseup touchend', onMouseUp);
	});
});

